import { Controller } from "@hotwired/stimulus"

// Shows only the fields that apply to the role currently selected on the user
// form: the client profile (rate, project names) for `client`, the ticket-access
// grant for `operator`, and the staff-only fields for everyone but `client`.
//
// Wire up:
//   <div data-controller="role-fields">
//     <select data-role-fields-target="role" data-action="change->role-fields#refresh">
//     <div data-role-fields-target="section" data-roles="client">…</div>
//   </div>
//
// A section is visible when its data-roles list contains the selected role.
export default class extends Controller {
  static targets = ["role", "section"]

  connect() {
    this.refresh()
  }

  refresh() {
    const selected = this.hasRoleTarget ? this.roleTarget.value : null

    this.sectionTargets.forEach((section) => {
      const roles = (section.dataset.roles || "").split(" ").filter(Boolean)
      section.classList.toggle("hidden", !roles.includes(selected))
    })
  }
}
